const groupCls = "_61gywhufx";
const headerCls = "_61h1c4knw4";
const headingCls = "_61htmnjr";
const switchCls = "_61s1vr0o3c";

export { groupCls, headerCls, headingCls, switchCls };
import "./chapter-group.style.linaria.module.css";
//# sourceMappingURL=chapter-group.style.js.map
